<div class="container mx-auto p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">{{ editMode ? 'Editar Empresa' : 'Nova Empresa' }}</h1>

  <form [formGroup]="form" class="space-y-4">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <!-- Tipo de Pessoa -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label class="mb-1 font-medium text-gray-700">Tipo de Pessoa</label>
        <div class="flex items-center space-x-4 mt-2">
          <label class="flex items-center space-x-2">
            <input type="radio" formControlName="tipoPessoa" value="FISICA" (change)="onTipoPessoaChange()" class="h-4 w-4" />
            <span>Física</span>
          </label>
          <label class="flex items-center space-x-2">
            <input type="radio" formControlName="tipoPessoa" value="JURIDICA" (change)="onTipoPessoaChange()" class="h-4 w-4" />
            <span>Jurídica</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Dados Principais -->
    <div class="grid grid-cols-1 md:grid-cols-10 gap-4">

      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="nomeRazao" class="mb-1 font-medium text-gray-700">Razão Social / Nome</label>
        <input pInputText id="nomeRazao" formControlName="nomeRazao" placeholder="Razão Social" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="cpfCnpj" class="mb-1 font-medium text-gray-700">{{ idLabel }}</label>
        <input pInputText id="cpfCnpj" formControlName="cpfCnpj" [mask]="idMask" [placeholder]="idLabel" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-1 flex flex-col">
        <label for="rgIE" class="mb-1 font-medium text-gray-700">RG / IE</label>
        <input pInputText id="rgIE" formControlName="rgIE" placeholder="RG ou IE" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="email" class="mb-1 font-medium text-gray-700">Email</label>
        <input pInputText id="email" formControlName="email" placeholder="Email" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="contato" class="mb-1 font-medium text-gray-700">Nome Contato</label>
        <input pInputText id="contato" formControlName="contato" placeholder="Nome do contato" class="w-full p-component rounded border-gray-300" />
      </div>

    </div>



    <!-- Contato e Endereço -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">

      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="cep" class="mb-1 font-medium text-gray-700">CEP</label>
        <p-inputMask id="cep" formControlName="cep" mask="99999-999" placeholder="CEP" styleClass="w-full"></p-inputMask>
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="endereco" class="mb-1 font-medium text-gray-700">Endereço</label>
        <input pInputText id="endereco" formControlName="endereco" placeholder="Rua, Av..." class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="numero" class="mb-1 font-medium text-gray-700">Número</label>
        <input pInputText id="numero" formControlName="numero" placeholder="Nº" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="bairro" class="mb-1 font-medium text-gray-700">Bairro</label>
        <input pInputText id="bairro" formControlName="bairro" placeholder="Bairro" class="w-full p-component rounded border-gray-300" />
      </div>

    </div>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">

      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="cidade" class="mb-1 font-medium text-gray-700">Cidade</label>
        <input pInputText id="cidade" formControlName="cidade" placeholder="Cidade" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-1 flex flex-col">
        <label for="estado" class="mb-1 font-medium text-gray-700">Estado</label>
        <input pInputText id="estado" formControlName="estado" placeholder="UF" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="celular" class="mb-1 font-medium text-gray-700">Celular</label>
        <p-inputMask id="celular" formControlName="celular" mask="(99) 9 9999-9999" placeholder="Celular" styleClass="w-full"></p-inputMask>
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="telefone" class="mb-1 font-medium text-gray-700">Telefone</label>
        <p-inputMask id="telefone" formControlName="telefone" mask="(99) 9999-9999" placeholder="Telefone" styleClass="w-full"></p-inputMask>
      </div>
      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="facebook" class="mb-1 font-medium text-gray-700">Facebook</label>
        <input pInputText id="facebook" formControlName="facebook" placeholder="Link Facebook" class="w-full p-component rounded border-gray-300" />
      </div>

    </div>

    <!-- Redes Sociais / Logos -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">

      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="instagram" class="mb-1 font-medium text-gray-700">Instagram</label>
        <input pInputText id="instagram" formControlName="instagram" placeholder="Link Instagram" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="logo1" class="mb-1 font-medium text-gray-700">Logo 1 (URL)</label>
        <input pInputText id="logo1" formControlName="logo1" placeholder="URL da Logo 1" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="logo2" class="mb-1 font-medium text-gray-700">Logo 2 (URL)</label>
        <input pInputText id="logo2" formControlName="logo2" placeholder="URL da Logo 2" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="planoAssinatura" class="mb-1 font-medium text-gray-700">Plano de Assinatura</label>
        <p-dropdown id="planoAssinatura" [options]="planoAssinaturaOptions" formControlName="planoAssinatura" placeholder="Selecione o plano" styleClass="w-full"></p-dropdown>
      </div>

    </div>

    <!-- Botões -->
    <div class="flex flex-wrap gap-4 pt-4 pb-6 border-b">
      <button pButton type="button" class="btn btn-primary btn-md" [disabled]="form.invalid || loading" (click)="salvar()">
        <i class="pi pi-check mr-2"></i>
        <span>{{ editMode ? 'Salvar' : 'Cadastrar' }}</span>
      </button>
      <button pButton type="button" class="btn btn-secondary btn-md" (click)="cancelar()">
        <i class="pi pi-times mr-2"></i>
        <span>{{ editMode ? 'Cancelar Edição' : 'Limpar' }}</span>
      </button>
    </div>
  </form>

  <!-- Lista de Empresas -->
  <div class="overflow-x-auto mt-8">
    <h2 class="text-xl font-semibold mb-4">Empresas Cadastradas</h2>
    <p-table [value]="empresas" [loading]="loading" class="w-full">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">ID</th>
          <th class="p-2 border-b text-left">Nome/Razão Social</th>
          <th class="p-2 border-b text-left">CPF/CNPJ</th>
          <th class="p-2 border-b text-left">Status</th>
          <th class="p-2 border-b text-left">Assinatura</th>
          <th class="p-2 border-b text-left">Plano</th>
          <th class="p-2 border-b text-left">Vencimento</th>
          <th class="p-2 border-b text-left">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-empresa>
        <tr>
          <td class="p-2 border-b">{{ empresa.id }}</td>
          <td class="p-2 border-b">{{ empresa.nomeRazao }}</td>
          <td class="p-2 border-b">{{ empresa.cpfCnpj }}</td>
          <td class="p-2 border-b">
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold"
                  [ngClass]="empresa.ativo ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
              {{ empresa.ativo ? 'Ativa' : 'Inativa' }}
            </span>
          </td>
          <td class="p-2 border-b">
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold"
                  [ngClass]="{
                    'bg-green-100 text-green-800': empresa.statusAssinatura === 'ATIVA' || empresa.statusAssinatura === 'TRIAL',
                    'bg-yellow-100 text-yellow-800': empresa.statusAssinatura === 'VENCIDA' || empresa.statusAssinatura === 'SUSPENSA',
                    'bg-red-100 text-red-800': empresa.statusAssinatura === 'BLOQUEADA' || empresa.statusAssinatura === 'CANCELADA'
                  }">
              {{ empresa.statusAssinatura }}
            </span>
          </td>
          <td class="p-2 border-b">{{ empresa.planoAssinatura }}</td>
          <td class="p-2 border-b">{{ empresa.dataVencimento }}</td>
          <td class="p-2 border-b">
            <div class="flex items-center space-x-1">
              <button pButton type="button" class="p-button-text p-button-sm text-gray-700" title="Editar Empresa" (click)="editar(empresa)">
                <i class="pi pi-pencil"></i>
              </button>
              <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="empresa.ativo ? 'text-red-600' : 'text-green-600'" [title]="empresa.ativo ? 'Desativar Empresa' : 'Ativar Empresa'" (click)="confirmarAtivarDesativar(empresa)">
                <i [ngClass]="empresa.ativo ? 'pi pi-ban text-red-600' : 'pi pi-user-plus text-green-600'"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="text-center p-4">Nenhuma empresa encontrada.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
